import React from 'react';

const PrevPage = (): JSX.Element => (
  <svg width="9" height="16" viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.00025 16C7.74425 16 7.48825 15.902 7.29325 15.707L0.29325 8.707C-0.0977501 8.316 -0.0977501 7.684 0.29325 7.293L7.29325 0.293002C7.68425 -0.0979979 8.31625 -0.0979979 8.70725 0.293002C9.09825 0.684002 9.09825 1.316 8.70725 1.707L2.41425 8L8.70725 14.293C9.09825 14.684 9.09825 15.316 8.70725 15.707C8.51225 15.902 8.25625 16 8.00025 16Z"
    />
  </svg>
);

export default PrevPage;
